import React, { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import './App.css';
import { Box } from '@mui/material';
import { useLocation, useRoutes } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import AppHeader from './components/AppHeader';
import { getAvailablePages } from './variables/Page';
import { appBarHeightAtom } from './atoms/AppHeader';
import SecureComponent from './components/Auth/SecureComponent';
import { tokenDataAtom } from './atoms/TokenData';
import LoginPage from './components/Auth/LoginPage';

const App = () => {
  const location = useLocation();
  const appBarHeight = useRecoilValue(appBarHeightAtom);
  const [tokenData] = useRecoilState(tokenDataAtom);

  const pages = getAvailablePages(tokenData);
  const isLoginPage = location.pathname === '/login';

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return undefined;

    // Allow the committed route (including a login redirect) to paint before
    // removing the native launch screen. No fixed startup delay is needed.
    let paintFrame: number;
    const frame = requestAnimationFrame(() => {
      paintFrame = requestAnimationFrame(() => {
        SplashScreen.hide().catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Unable to hide the launch screen', error);
        });
      });
    });

    return () => {
      cancelAnimationFrame(frame);
      cancelAnimationFrame(paintFrame);
    };
  }, []);

  const routes = useRoutes([
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: '/',
      element: <SecureComponent>{pages[0].component}</SecureComponent>,
    },
    {
      path: '',
      element: <SecureComponent>{pages[0].component}</SecureComponent>,
    },
    ...pages.map((page) => ({
      path: `${page.path}/*`,
      element: (
        <SecureComponent>
          {page.disabled ? <></> : page.component}
        </SecureComponent>
      ),
    })),
  ]);

  return (
    <Box
      component='div'
      sx={{
        paddingTop: isLoginPage ? 'var(--app-safe-area-top)' : 0,
        paddingRight: 'var(--app-safe-area-right)',
        paddingBottom: 'var(--app-safe-area-bottom)',
        paddingLeft: 'var(--app-safe-area-left)',
      }}
    >
      {!isLoginPage && (
        <>
          <AppHeader />
          <Box component='div' sx={{ height: appBarHeight }} />
        </>
      )}
      {routes}
    </Box>
  );
};

export default App;
